import type { SettingsPreset } from './types.js'

export const builtInPresets: SettingsPreset[] = [
	{
		id: 'default',
		name: 'ViewSettings.presets.default.name',
		description: 'ViewSettings.presets.default.description',
		values: {}
	}
]
